module.exports = __webpack_public_path__ + "static/img/level-card-banner1.07b0ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/level-card-banner1.png
// module id = 1q4T
// module chunks = 1